import { render, staticRenderFns } from "./CardFront.vue?vue&type=template&id=0afadc80"
import script from "./CardFront.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports